import React from 'react';
import { 
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Chart, Bar, Doughnut } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';

// Chart.js 컴포넌트 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

interface ChartsSectionProps {
  mixedChartData: any;
  itemGroupChartData: any;
  batchDefectDoughnutData: any;
  kpiSendStatusData: any;
}

// 차트 옵션 설정
export const chartOptions = {
  // 혼합 차트 옵션
  mixedChart: {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  } as ChartOptions<'bar'>,

  // 바 차트 옵션
  barChart: {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: '수량 (개)'
        }
      },
    },
  } as ChartOptions<'bar'>,

  // 도넛 차트 옵션
  doughnutChart: {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
  } as ChartOptions<'doughnut'>,
}; 

export const ChartsSection: React.FC<ChartsSectionProps> = ({
  mixedChartData,
  itemGroupChartData,
  batchDefectDoughnutData,
  kpiSendStatusData
}) => {
  return (
    <div className="flex-1 grid grid-cols-4 gap-4 min-h-0">
      {/* 브랜드별 생산실적 현황 */}
      <div className="bg-white p-4 rounded-lg shadow flex flex-col">
        <h2 className="text-lg font-semibold mb-2">브랜드별 생산실적 현황</h2>
        <div className="flex-1 min-h-0">
          <Chart
            type="bar"
            data={mixedChartData}
            options={chartOptions.mixedChart}
          />
        </div>
      </div>

      {/* 월별 불량현황 */}
      <div className="bg-white p-4 rounded-lg shadow flex flex-col">
        <h2 className="text-lg font-semibold mb-2">월별 불량현황</h2>
        <div className="flex-1 min-h-0">
          <Bar 
            data={itemGroupChartData}
            options={chartOptions.barChart}
          />
        </div>
      </div>

      {/* 품목그룹별 생산실적 현황 */}
      <div className="bg-white p-4 rounded-lg shadow flex flex-col">
        <h2 className="text-lg font-semibold mb-2">품목그룹별 생산실적 현황</h2>
        <div className="flex-1 min-h-0">
          <Doughnut 
            data={batchDefectDoughnutData}
            options={chartOptions.doughnutChart}
          />
        </div>
      </div>

      {/* KPI 전송현황 */}
      <div className="bg-white p-4 rounded-lg shadow flex flex-col">
        <h2 className="text-lg font-semibold mb-2">KPI 전송현황</h2>
        <div className="flex-1 min-h-0">
          <Doughnut 
            data={kpiSendStatusData}
            options={chartOptions.doughnutChart}
          />
        </div>
      </div>
    </div>
  );
}; 